import { useDatasetsSyncingToAnalytics } from '@monorepo/shared/hooks/analyticsSync/useDatasetsSyncingToAnalytics';
import { useIsSuperAdmin } from '@monorepo/shared/hooks/permissions/useIsSuperAdmin';
import { useDatasetForOrigin } from '@monorepo/shared/hooks/datasets/useDatasetByOrigin';
import React from 'react';
import styled from 'styled-components';
import { Description } from '../../Description';
import { Loading } from '../../Loading';
import { SectionContainer, SectionHeader } from '../styled/fullPageWizard';
import { AnalyticsSyncActiveChip } from './AnalyticsSyncActiveChip';
import { CopySqlButton } from './CopySqlButton';

const StyledAnalyticsSyncActiveChip = styled(AnalyticsSyncActiveChip)`
  margin-right: 1rem;
`;

// put it under the section header
const LeftAlignedLoading = styled(Loading)`
  width: fit-content;
  margin: 0 1rem;
`;

export function AnalyticsSyncDetailsSection({
  datasetOriginId,
  organizationId,
  datasetId: passedDatasetId,
  datasetOriginLabel,
}: {
  datasetOriginId: string;
  organizationId: string;
  datasetId?: string;
  datasetOriginLabel: string;
}) {
  const isSuperAdmin = useIsSuperAdmin();
  const { datasetsSyncingToAnalytics, isLoading } =
    useDatasetsSyncingToAnalytics({
      organizationId,
    });
  const isSyncedToAnalytics = datasetsSyncingToAnalytics?.some(
    (dataset) => dataset.originId === datasetOriginId,
  );

  const { dataset, isLoading: isLoadingDataset } = useDatasetForOrigin({
    organizationId,
    originId: datasetOriginId,
    config: {
      enabled: !passedDatasetId && isSuperAdmin, // only fetch dataset for the origin if we don't have the ID passed to us
    },
  });
  const datasetId = passedDatasetId || dataset?.id;

  const getContent = () => {
    if (isLoading || isLoadingDataset) {
      return <LeftAlignedLoading size="small" />;
    }

    if (!isSyncedToAnalytics) {
      return <Description>Data is not synced to analytics.</Description>;
    }

    return (
      <>
        <StyledAnalyticsSyncActiveChip />
        {isSuperAdmin && datasetId && (
          <CopySqlButton
            datasetOriginLabel={datasetOriginLabel}
            datasetId={datasetId}
            organizationId={organizationId}
          />
        )}
      </>
    );
  };

  return (
    <SectionContainer>
      <SectionHeader>Analytics</SectionHeader>
      {getContent()}
    </SectionContainer>
  );
}
